export const inputValue = (event: Event) => (event.target as HTMLInputElement).value
export const inputNumber = (event: Event) => Number((event.target as HTMLInputElement).value)
export const inputChecked = (event: Event) => (event.target as HTMLInputElement).checked
export const selectValue = (event: Event) => (event.target as HTMLSelectElement).value
